import Joi from "joi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Toast from "../../helpers/Toast";
import { CreateSubcontractorDTO } from "../../models/Subcontractor/CreateSubcontractorDTO";
import { SubcontractorService } from "../../services/SubcontractorService";

export default function SubcontractorCreate() {
    const intl = useIntl();
    const subcontractorService = new SubcontractorService();
    const [subcontractor, setSubcontractor] = useState<CreateSubcontractorDTO>({} as CreateSubcontractorDTO);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    const navigate = useNavigate();

    const schemaSubcontractorValidation = Joi.object({
        companyName: Joi.string()
            .required()
            .messages({
                "any.required": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.CompanyNameRequired",
                }),
                "string.base": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.CompanyNameRequired",
                }),
                "string.empty": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.CompanyNameRequired",
                }),
            }),
        address: Joi.string()
            .required()
            .messages({
                "any.required": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.AddressRequired",
                }),
                "string.base": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.AddressRequired",
                }),
                "string.empty": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.AddressRequired",
                }),
            }),
        vatNumber: Joi.string()
            .required()
            .messages({
                "any.required": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.VatNumberRequired",
                }),
                "string.base": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.VatNumberRequired",
                }),
                "string.empty": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.VatNumberRequired",
                }),
            }),
        phoneNumber: Joi.string()
            .required()
            .messages({
                "any.required": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.PhoneNumberRequired",
                }),
                "string.base": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.PhoneNumberRequired",
                }),
                "string.empty": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.PhoneNumberRequired",
                }),
            }),
        email: Joi.string()
            .required()
            .messages({
                "any.required": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.EmailRequired",
                }),
                "string.base": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.EmailRequired",
                }),
                "string.empty": intl.formatMessage({
                    id: "Screens.Subcontractors.Validation.EmailRequired",
                }),
            }),

    });

    const CreateSubcontractor = async () => {
        validateSubcontractor(subcontractor.companyName!, subcontractor.address!, subcontractor.vatNumber!, subcontractor.phoneNumber!, subcontractor.email!).then(async (result: any) => {
            setIsLoading(true);
            if (result.error != null) {
                setIsLoading(false);
            } else {
                const CreateSubcontractor: CreateSubcontractorDTO = {
                    companyName: subcontractor.companyName,
                    address: subcontractor.address,
                    vatNumber: subcontractor.vatNumber,
                    phoneNumber: subcontractor.phoneNumber,
                    email: subcontractor.email

                };

                const response = await subcontractorService.Create(CreateSubcontractor);

                if (response.success !== true) {
                    Toast.Show("error", response.message);
                    setIsLoading(false);
                    return;
                }
                Toast.Show("success", response.message);
                setIsLoading(false);
                navigate(-1);
            }
        });
    };

    const validateSubcontractor = (companyName: string, address: string, vatNumber: string, phoneNumber: string, email: string) => {
        return new Promise(function (resolve) {
            var validationResult = schemaSubcontractorValidation.validate(
                {
                    companyName: companyName,
                    address: address,
                    vatNumber: vatNumber,
                    phoneNumber: phoneNumber,
                    email: email
                },
                { abortEarly: false }
            );

            resolve(validationResult);

            if (validationResult.error != null) {
                var message = validationResult.error!.message;
                Toast.Show("error", message);
                return false;
            }
        });
    };

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle
                        title={intl.formatMessage({ id: 'Screens.Subcontractors.Create.Title' })}
                        allowGoBack={true}
                    />
                </div>
                <div className="pageBody">
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>{intl.formatMessage({ id: 'Screens.Subcontractors.Create.Subtitle' })}</b>
                    </label>
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-start", alignContent: "flex-start" }}>
                        <Row>
                            <InputComponent
                                xl={6}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={subcontractor.companyName}
                                label={intl.formatMessage({ id: "Screens.Subcontractors.Info.CompanyName" })}
                                readOnly={false}
                                showLoadingSkeleton={isLoading}
                                onChange={(companyName: string) => {
                                    setSubcontractor({ ...subcontractor!, companyName: companyName });
                                }}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={2}
                                lg={3}
                                md={3}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={subcontractor.vatNumber}
                                label={intl.formatMessage({ id: "Screens.Subcontractors.Info.VatNumber" })}
                                readOnly={false}
                                showLoadingSkeleton={isLoading}
                                onChange={(vatNumber: string) => {
                                    setSubcontractor({ ...subcontractor!, vatNumber: vatNumber });
                                }}
                            />
                            <InputComponent
                                xl={2}
                                lg={2}
                                md={2}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={subcontractor.phoneNumber}
                                label={intl.formatMessage({ id: "Screens.Subcontractors.Info.PhoneNumber" })}
                                readOnly={false}
                                showLoadingSkeleton={isLoading}
                                onChange={(phoneNumber: string) => {
                                    setSubcontractor({ ...subcontractor!, phoneNumber: phoneNumber });
                                }}
                            />
                            <InputComponent
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={subcontractor.email}
                                label={intl.formatMessage({ id: "Screens.Subcontractors.Info.Email" })}
                                readOnly={false}
                                showLoadingSkeleton={isLoading}
                                onChange={(email: string) => {
                                    setSubcontractor({ ...subcontractor!, email: email });
                                }}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={6}
                                lg={8}
                                md={8}
                                sm={12}
                                xs={12}
                                style={{ width: "100%" }}
                                type={"text"}
                                value={subcontractor.address}
                                label={intl.formatMessage({ id: "Screens.Subcontractors.Info.Address" })}
                                readOnly={false}
                                showLoadingSkeleton={isLoading}
                                onChange={(address: string) => {
                                    setSubcontractor({ ...subcontractor!, address: address });
                                }}
                            />
                        </Row>
                        <Row style={{ margin: "0px", marginTop: "10px", padding: "0px" }}>
                            <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                <ButtonComponent
                                    disabled={isLoading}
                                    loading={isLoading}
                                    text={intl.formatMessage({ id: "Screens.Subcontractors.Button.SaveSubcontractor" })}
                                    onClick={CreateSubcontractor}
                                />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </div>
        </Layout >
    );
}
